module.exports = __webpack_public_path__ + "img/qr_notmember_screenshot_MAGAZINE.862c1d48.png";